import { Form, Modal } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import SettleInstallmentSingleForm from './SettleInstallmentSingleForm';
import { SettleInstallmentSingleFormValues } from './SettleInstallmentSingleForm/types';
import { SettleInstallmentSingleModalProps } from './types';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const SettleInstallmentSingleModal: React.FC<
  SettleInstallmentSingleModalProps
> = ({ onOk, onCancel, data, ...props }) => {
  const [form] = Form.useForm<SettleInstallmentSingleFormValues>();

  const today = moment().format('YYYY-MM-DD');
  const payDate = Form.useWatch('payDate', form);

  const isEarlierDate = moment(payDate).isBefore(today);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        payDate: moment(),
        netValue: (data.installmentValue || 0) + (data.discountIncrease || 0),
        ...data,
      });
    }
  }, [data]);

  async function handleOk() {
    try {
      const values = await form.validateFields();

      await onOk(values);
      handleCancel();
    } catch {}
  }

  function handleCancel() {
    onCancel();
    form.resetFields();
  }

  return (
    <Modal
      title="Liquidar parcela"
      okText="Liquidar"
      {...props}
      onCancel={handleCancel}
      onOk={handleOk}
      okButtonProps={{
        disabled:
          isEarlierDate &&
          !hasPermissions([
            Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_SETTLE_REFUND_WITH_PREVIOUS_DATE,
          ]),
      }}
      width={500}
    >
      <SettleInstallmentSingleForm form={form} />
    </Modal>
  );
};

export default SettleInstallmentSingleModal;
